import React from 'react';
import {
  Box,
  MenuItem,
  SelectChangeEvent,
  SelectWrapper,
  Typography,
} from '@barracuda-internal/bds-core-v2';
import OutlinedInput from '@barracuda-internal/bds-core-v2/dist/OutlinedInput';

const options = [
  { value: 'Ignore classifier', label: 'Ignore classifier', description: 'No action will be taken to the specified classifier(s) but the file will continue to be checked against other policies.' },
  { value: 'Report file', label: 'Report file', description: 'File will be shown on the Data Inspector detections unresolved tab.' },
  { value: 'Quarantine file', label: 'Quarantine file', description: 'File will be moved to the "DI_QUARANTINE" folder which will be present at the root level.' },
  { value: 'UnShare file', label: 'UnShare file', description: "File will have its sharing permissions and links removed and be restricted to Private and only the owners will have access." },
  { value: 'Delete file', label: 'Delete file', description: "File will be deleted from the user's drive and moved to Recycle Bin" }
];

type SelectedAction = {
  current: string[];
};

type ActionsProps = {
  selectedAction: SelectedAction;
}

function Actions({selectedAction}: ActionsProps) {
  selectedAction.current = selectedAction.current.length > 0 ? selectedAction.current: [options[1].value];
  const [selectedValue, setSelectedValue] = React.useState(selectedAction.current[0]);

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedValue(event.target.value);
    selectedAction.current = [event.target.value];
  };

  return (
    <SelectWrapper
      fullWidth
      input={<OutlinedInput label="Action" />}
      labelId="action-select-label"
      id="action-select"
      value={selectedValue}
      label="Action"
      onChange={handleChange}
      sx={{ width: '300px', fontSize: '14px' }}
      renderValue={(selected) => {
        const selectedOption = options.find(option => option.value.startsWith(selected as string));
        return selectedOption ? selectedOption.label : '';
      }}
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value} sx={{ width: '300px' }}>
          <Box>
            <Typography
              variant="body2"
              sx={{ fontSize: '14px', fontWeight: 500, display: 'inline-block' }}
            >
              {option.label}
            </Typography>
            <br/>
            <Typography
              variant="caption"
              sx={{
                fontSize: '0.8em',
                color: 'gray',
                fontWeight: 500,
                whiteSpace: 'normal',
              }}
            >
              {option.description}
            </Typography>
          </Box>
        </MenuItem>
      ))}
    </SelectWrapper>
  );
}

export default Actions;